import { CommonModule } from "@angular/common";
import { Component, computed, inject, input } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { toSignal } from "@angular/core/rxjs-interop";
import { DocumentCardParams } from "../../pre-document/pre-document-card/pre-document-card";
import { Icon, ModalService, ScreenSizeService } from "@malirang/front-share";
import {
    FixDocumentContentModal,
    FixDocumentContentModalProps,
} from "../../../pages/fix-document/fix-document-content/fix-document-content.modal";

@Component({
    selector: "app-document-card",
    templateUrl: "./document-card.html",
    styleUrls: ["./document-card.css"],
    imports: [CommonModule, Icon],
})
export class DocumentCard {
    readonly router = inject(Router);
    readonly route = inject(ActivatedRoute);
    readonly modalService = inject(ModalService);
    readonly screenSizeService = inject(ScreenSizeService);

    params = input.required<DocumentCardParams>();
    document = computed(() => this.params()?.document);

    readonly queryParams = toSignal(this.route.queryParams);

    lock = computed(() => this.params()?.lock);

    isActive = computed(() => {
        const currentType = this.queryParams()?.["type"];
        return currentType === this.params().value;
    });

    handleDetail() {
        if (this.lock()) {
            return;
        }

        // 문서가 있으면 해당 문서 ID로, 없으면 "new"로 detail 페이지 이동
        const documentId = this.document()?.id;
        const type = this.params().value;
        const phase = this.params().phase;

        // 모바일/태블릿에서는 모달로 표시 (기존 문서만)
        if (this.screenSizeService.isTabletOrMobile() && documentId) {
            this.modalService.create<FixDocumentContentModalProps>(
                FixDocumentContentModal,
                {
                    componentProps: {
                        documentId: documentId,
                    },
                },
            );
            return;
        }

        this.router.navigate(
            [`/document/document-box/fix/${documentId || "new"}`],
            {
                queryParams: {
                    type,
                    phase,
                },
                queryParamsHandling: "merge",
            },
        );
    }
}
